import "esbuild-css-modules-plugin-ns-css:src/artifacts/shared/styles/icon/custom.module.css";

export default {
  "icon": "custom-module__icon_aFjlhW__010"
};
      